<template>
  <div class="c-popup-slide c-popup-slide--right" :id="id">
    <div class="c-popup-slide__backdrop c-btn-popup-slide-close" :data-popup-id="id"></div>
    <div class="c-popup-slide__container add_package_slide px-0">
      <!-- @start Header-->
      <div class="header_add_packagev2">
        <div class="c-btn-popup-slide-close back_button" :data-popup-id="id">
          <svg width="32" height="32" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000">
            <path d="m15 6-6 6 6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="header_title">Agregar paquete</div>
      </div>

      <!-- @start content-->
      <div class="body_add_packagev2">
        <div class="sections_container">

          <!-- Tipo de envío -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Tipo de envío" />
            <div style="margin: -12px -12px 0 -12px;">
              <CustomRadioButton
                radioId="opcion1"
                :inputValue="typesOfShipments.pointToHome"
                v-model="shipmentType"
                label="Punto Sharf a domicilio"
              />
              <CustomRadioButton
                radioId="opcion2"
                :inputValue="typesOfShipments.pointToPoint"
                v-model="shipmentType"
                label="Punto Sharf a Punto Sharf"
              />
            </div>
          </div>

          <!-- Método de pago -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Método de pago" />
            <div style="margin: -12px -12px 0 -12px;">
              <CustomRadioButton
                radioId="opcion3"
                :inputValue="false"
                v-model="isShippingPaidAtDestination"
                label="Pago en línea"
              />
              <CustomRadioButton
                radioId="opcion4"
                :inputValue="true"
                v-model="isShippingPaidAtDestination"
                label="Pago al recoger el paquete"
                :disabled="shipmentType === typesOfShipments.pointToHome"
                :helperText="shipmentType === typesOfShipments.pointToHome ? 'Disponible en Punto Sharf a Punto Sharf' : 'Este pago corresponde únicamente al servicio de envío'"
              />
            </div>
          </div>

          <!-- Lugar de entrega -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Lugar de entrega" />
            <div v-show='shipmentType === typesOfShipments.pointToHome' class="delivery-place-inputs">
              <SelectAddressButton
                @click='openAddressesModal()'
                :addressData='DestinationAddress'
              />
              <div v-if="tryToAddPackage && !DestinationAddress" style="margin-top: -15px;">
                <ErrorMessage message="Escoge un dirección." />
              </div>
            </div>
            <div v-show='shipmentType === typesOfShipments.pointToPoint' class="delivery-place-inputs">
              <CustomSearchSelect
                v-show='!isShippingPaidAtDestination'
                @itemSelected="setDestinationDistrictData"
                ref="CustomSelectComponentRef"
                v-model="destinationDistrictId"
                :repoSearch="getScharffDistrics"
                label="Distrito"
                placeholder="Busca por departamento, provincia o distrito"
                errorMessage="Ingresa un departamento, provincia o distrito y selecciona uno de los resultados sugeridos."
                :showEmptyInputError="tryToAddPackage && !destinationDistrictId"
              />
              <ErrorMessage v-if="!hasLimaOrCallaoDistrict" style="margin-top: 3px" message="Por el momento solo realizamos envíos de Lima Metropolitana a provincia y de provincia a Lima Metropolitana. Intenta ingresar nuevamente un departamento, provincia o distrito y selecciona uno de los resultados sugeridos."/>

              <!-- Point to point -->
              <!-- Paying at destination has no district filter, so the list is searched server-side -->
              <CustomSearchSelect
                v-if="shipmentType === typesOfShipments.pointToPoint && isShippingPaidAtDestination"
                ref="cashOnDeliveryPointRef"
                @itemSelected="setMarketV2"
                v-model="destinationPuntoScharff"
                :repoSearch="searchCashOnDeliveryPoints"
                :isPoint="true"
                label="Punto Sharf"
                placeholder="Busca por nombre, dirección o distrito"
                errorMessage="Selecciona un Punto Sharf."
                :showEmptyInputError="tryToAddPackage && !destinationPuntoScharff"
              />
              <CustomSelect
                isForScharffPoints
                v-if="shipmentType === typesOfShipments.pointToPoint && !isShippingPaidAtDestination"
                label="Punto Sharf"
                placeholder="Selecciona un Punto Sharf"
                :optionList="scharffPointsList"
                :isLoading="scharffPointsAreLoading"
                v-model="destinationPuntoScharff"
                errorMessage="Selecciona un Punto Sharf."
                :showEmptyInputError="tryToAddPackage && !destinationPuntoScharff"
                @change="setMarketV2"
              />
              <PointCapacityTag v-if="shipmentType === typesOfShipments.pointToPoint" :point="selectedScharffPointData" />
              <div v-show="shipmentType === typesOfShipments.pointToPoint" class="c-popup-slide__map" id="mp_ps_type1"></div>

              <!-- Point to home -->
              <InputText
                v-if="shipmentType === typesOfShipments.pointToHome"
                label="Dirección"
                :maxLength="150"
                placeholder="Calle/avenida, número, departamento, etc."
                v-model="address"
                missingErrorMessage="Ingresa una dirección."
                :showEmptyInputError="tryToAddPackage && !address"
                :showExtraMessage="true"
                extraMessage="*Todos nuestros recojos y entregas se realizan en el primer piso de la vivienda"
              />
              <InputText
                isOptional
                v-if="shipmentType === typesOfShipments.pointToHome"
                label="Referencia (opcional)"
                :maxLength="150"
                placeholder="Manzana, lote, alrededores"
                v-model="reference"
                missingErrorMessage="Ingresa una referencia."
              />
            </div>
          </div>

          <!-- Datos de quien recibe -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Datos de quien recibe" />
            <div class="delivery-place-inputs">
              <DestinationContactButton
                @click="openContactModal('destination'), trackEvent('click_puntos_envia_paso_3_contacto_btn', `${shipmentType == typesOfShipments.pointToHome ? 'dropoff': 'puntoapunto'}`)"
                :destinationContact="DestinationContact"
                missingErrorMessage="Escoge un contacto. 2"
              />
              <div v-if="tryToAddPackage && !DestinationContact" style="margin-top: -15px;">
                <ErrorMessage
                  message="Escoge un contacto."
                />
              </div>
            </div>
          </div>

          <!-- Código de seguridad -->
          <div v-if='shipmentType === typesOfShipments.pointToPoint' class='title_section-and-section'>
            <FormSectionTitle title='Código de seguridad' />
            <div>
              <label class="custom-input-label">La persona que recibe debe dar el código de seguridad para poderle entregar el paquete</label>
              <div style='display: flex; gap: 10px; align-items: flex-start;' class="pt-1">
                <InputText
                :maxLength='4'
                placeholder='Ej. 4729'
                v-model='securityCode'
                missingErrorMessage='Ingresa un código de seguridad de 4 dígitos.'
                :showEmptyInputError='tryToAddPackage && !securityCode'
              />
              <div style='width: 250px; margin: -4px'>
                <ButtonDefinitive
                variant='secondary'
                size='md'
                label='Generar código'
                @click='generateSecurityCode'
                />
              </div>
            </div>
          </div>
          <div style='margin-top: 6px;'>
              <InformativeMessage
              :message="'Debe tener 4 números. Evita repetir (1111) o poner secuencias (1234). Puedes usar “Generar código”.'"
              />
            </div>
          </div>

          <!-- Características del paquete -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Características del paquete" />
            <div class="delivery-place-inputs">
              <InputText
                label="Descripción del producto"
                :maxLength="150"
                placeholder="¿Qué es lo que envías?"
                v-model="productDescription"
                missingErrorMessage="Ingresa la descripción del producto."
                :showEmptyInputError="tryToAddPackage && !productDescription"
              />
              <CustomCheckbox
                checkboxId="fragile-product"
                v-model="isAFragileProduct"
                label="Producto frágil"
              />
              <div style='padding: 12px 0 16px 0'>
                <InformativeMessage :message="'⚠️ Importante: Si envías más de un paquete, registra cada uno por separado con su propia guía. Esto garantiza una correcta trazabilidad y evita demoras, pérdidas o extravíos.'" />
                <!-- <InformativeMessage :message="'¡Tus paquetes se miden en 3D! 🔍\nAunque una medida parezca grande, el volumen total podría clasificarse en una talla menor. Te ayudamos a encontrar la mejor opción según sus dimensiones completas 📏×📐×📎'" /> -->
              </div>
              <div class="package_measurements">
                <div class="size_mode_selector">
                  <CustomRadioButton
                    radioId="sizeModeCatalogPtH"
                    inputValue="catalog"
                    :value="packageSizeMode"
                    @input="handleSizeModeChange"
                    label="Elegir una talla"
                    helperText="Escoge la talla que se ajuste a tu paquete"
                  />
                  <CustomRadioButton
                    radioId="sizeModeManualPtH"
                    inputValue="manual"
                    :value="packageSizeMode"
                    @input="handleSizeModeChange"
                    label="Ingresar las medidas"
                    :helperText="canUseManualMode ? 'Calculamos la talla a partir de las medidas de tu paquete' : manualSizeOptionCompatibility.reason"
                    :disabled="!canUseManualMode"
                  />
                </div>
                <PackageSizes v-if="!isManualMode" :sizeList='compatibleSizeList' :sizeSelectedId='sizeSelected.tallaId' @onSizeSelected='handleSizeSelected' />
                <ErrorMessage isHtml v-if="selectedSizeCompatibilityMessage && !(isManualMode && effectiveSize)" :message="selectedSizeCompatibilityMessage" />
                <ErrorMessage v-if="classificationError" :message="classificationError" />
                <div v-if="isManualMode" class="attributes">
                  <InputPackageAttribute
                    label="Peso"
                    measure="kg"
                    v-model="packageWeight"
                    missingErrorMessage="Ingresa el Peso."
                    :showEmptyInputError="tryToAddPackage && !packageWeight"
                  />
                </div>
                <ErrorMessage v-show="exceedsWeightLimit" :message="`El peso máximo permitido por paquete en el servicio Puntos Sharf es ${maxWeight} kg.`" />
                <div v-if="isManualMode" style="padding-top: 16px;" class="attributes">
                  <InputPackageAttribute
                    label="Largo"
                    measure="cm"
                    v-model="packageWidth"
                    missingErrorMessage="Ingresa el Largo."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageWidth"
                  />
                  <InputPackageAttribute
                    label="Alto"
                    measure="cm"
                    v-model="packageHeight"
                    missingErrorMessage="Ingresa el Alto."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageHeight"
                  />
                  <InputPackageAttribute
                    label="Ancho"
                    measure="cm"
                    v-model="packageDeep"
                    missingErrorMessage="Ingresa el Ancho."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageDeep"
                  />
                </div>
                <ErrorMessage
                  v-if="
                    packageWidth <= maxLength &&
                    packageHeight <= maxLength &&
                    packageDeep <= maxLength
                  "
                  :message="volumetricWeightMsg"
                  v-show="exceedsVolumetricWeight"
                />
                <div class="attributes" style="padding-top: 16px">
                  <InputPackageAttribute
                    label="Valor del producto"
                    measure="S/"
                    v-model="packageValue"
                    missingErrorMessage="Ingresa el valor del producto."
                    :showEmptyInputError="tryToAddPackage && !packageValue"
                    isCurrency
                  />
                </div>
                <!-- Result goes last so it never shifts the fields being filled in -->
                <div v-if="isManualMode && effectiveSize" class="calculated_size" :class="isSelectedSizeCompatible ? 'is-valid' : 'is-invalid'">
                  <div class="calculated_size--head">
                    <span class="text-s-light">Talla calculada</span>
                    <span class="calculated_size--value">
                      <svg v-if="isSelectedSizeCompatible" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" stroke="#00CCAA" stroke-width="2" />
                        <path d="m8.5 12.2 2.4 2.4 4.6-4.9" stroke="#00CCAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <strong>{{ effectiveSize.code }} · {{ effectiveSize.description }}</strong>
                    </span>
                  </div>
                  <ul class="calculated_size--detail">
                    <li>
                      <span>Medidas ingresadas</span>
                      <strong>{{ packageWidth }} × {{ packageHeight }} × {{ packageDeep }} cm</strong>
                    </li>
                    <li>
                      <span>Peso real</span>
                      <strong>{{ packageWeight }} kg</strong>
                    </li>
                    <li>
                      <span>Peso volumétrico</span>
                      <strong>{{ volumetricWeightKg }} kg</strong>
                    </li>
                    <li class="calculated_size--formula">
                      {{ packageWidth }} × {{ packageHeight }} × {{ packageDeep }} / {{ volumetricRatio }} = {{ volumetricWeightKg }} kg
                    </li>
                  </ul>
                  <div
                    v-if="!isSelectedSizeCompatible && selectedSizeCompatibilityMessage"
                    class="calculated_size--error"
                    v-html="selectedSizeCompatibilityMessage"
                  ></div>
                </div>
              </div>
              <div style="padding-top: 8px">
                <InformativeMessage message="Tenemos garantía de hasta S/ 700." />
              </div>
            </div>
          </div>
          <!-- <div v-if="allowSecondAttempt && shipmentType === typesOfShipments.pointToHome">
            <div style="display: flex; flex-direction: column; gap: 4px;">
              <div class="text-l-bold">En caso el destinatario no pueda recibir el paquete</div>
              <div class="text-s-regular" style="color: #737373">Escoge una opción</div>
            </div>
            <div class="secondAttemptOption_container">
              <SecondAttempCards
                :optionSelected="secondAttemptInPS"
                :isLoading="shippingCostIsLoading"
                :aditionalCostCalculated="aditionalCostCalculated"
                @onUpdateOption="updateSecondAttemptOption"
              />
            </div>
            <div class="text-s-regular">El cobro adicional se realizaría solo en caso de que hubiese un 2do intento de entrega en domicilio, luego de haber coordinado contigo.</div>
          </div> -->

          <!-- Información adicional (opcional) -->
          <!-- <div class="title_section-and-section">
            <FormSectionTitle title="Información adicional (opcional)" />
            <InputText
              isTextArea
              placeholder="¿Deseas agregar alguna indicación para tu envío?"
              v-model="adicionalInformation"
            />
          </div> -->

        </div>

        <div class="body_footer">
          <div>
            <ButtonDefinitive
              :isDisabled="shippingCostIsLoading"
              label="Guardar paquete"
              @click="handleAddPackage"
            />
          </div>
          <ShippingCost :isLoading="shippingCostIsLoading" :amount="shippingCost" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PointCapacityTag from "@/components/Shared/PointCapacityTag.vue";
import M from "materialize-css";
import InputDistrict from "../General/InputDistrict.vue";
import FavoriteAddress from "../General/FavoriteAddress.vue";
import Map from "../../commons/mixins/maps";
import utils from "../../commons/mixins/utils";
import PackageSizes from "@/components/Shared/PackageSizes.vue";
import SelectAddressButton from "@/components/Button/SelectAddressButton.vue"
import Icon from '@/components/Icon.vue'

import CustomRadioButton from "../Form/CustomRadioButton.vue";
import FormSectionTitle from "../Form/FormSectionTitle.vue";
import CustomSearchSelect from "../Form/CustomSearchSelect.vue";
import { getScharffDistrics, getScharffPoints, getFare, getSizes, classifySize } from "../../services/fare"
import { normalizeScharffPoint, normalizeScharffPoints } from "@/utils/scharffPoint"
import InputText from "../Form/InputText.vue";
import DestinationContactButton from "../Button/DestinationContactButton.vue";
import CustomCheckbox from "../Form/CustomCheckbox.vue";
import ErrorMessage from "../ErrorMessage.vue";
import InputPackageAttribute from "../Form/InputPackageAttribute.vue";
import InformativeMessage from "../General/InformativeMessage.vue";
import ButtonDefinitive from "../Button/ButtonDefinitive.vue";
import ShippingCost from "../General/ShippingCost.vue";
import CustomSelect from "../Form/CustomSelect.vue";
import SecondAttempCards from "../Shared/SecondAttempt/SecondAttempCards.vue" 
import {
  CUSTOM_SIZE_CODE,
  decorateSizesWithCompatibility,
  getManualSizeOptionCompatibility,
  getSizeCompatibility,
  normalizePointMaximumSize,
} from "../../utils/puntoScharffCapacity";
import { createRequestVersion } from "../../utils/puntoScharffRequestVersion";

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      timeout = null
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export default {
  components: {
    PointCapacityTag,
    InputDistrict,
    FavoriteAddress,
    PackageSizes,
    SelectAddressButton,
    Icon,

    CustomRadioButton,
    FormSectionTitle,
    CustomSearchSelect,
    InputText,
    DestinationContactButton,
    CustomCheckbox,
    ErrorMessage,
    InputPackageAttribute,
    InformativeMessage,
    ButtonDefinitive,
    ShippingCost,
    SecondAttempCards,
    CustomSelect
  },
  name: "ModalScharffPointPackageV2",
  props: {
    id: String
  },
  data() {
    return {
      typesOfShipments: {
        pointToHome: 'PtH',
        pointToPoint: 'PtP'
      },
      shipmentType: 'PtH',
      destinationDistrictId: '',
      destinationPuntoScharff: '',
      scharffPointsList: [],
      address: '',
      reference: '',
      securityCode: null,
      productDescription: '',
      isAFragileProduct: false,
      maxLength: null,
      maxWeight: null,
      maxVolumetricWeight: null,
      // API2 publishes the volumetric divisor alongside the size catalog.
      volumetricRatio: 5000,
      packageWeight: 0,
      packageWidth: 0,
      packageHeight: 0,
      packageDeep: 0,
      packageValue: 0,
      adicionalInformation: '',
      package: {
        hasValueCalculable: false,
        isAddableToList: false
      },
      shippingCostIsLoading: false,
      shippingCost: 0,
      tryToAddPackage: false,
      destinationDistrictData: {},
      scharffPointsAreLoading: false,
      selectedScharffPointData: {},
      allowSecondAttempt: false,
      secondAttemptInPS: true,
      aditionalCostCalculated: 0,
      isShippingPaidAtDestination: false,
      sizeList: [],
      sizeSelected: {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      },
      effectiveSize: null,
      packageSizeMode: 'catalog',
      classificationError: '',
      fareRequests: createRequestVersion(),
      pointListRequests: createRequestVersion(),
      map: null,
    };
  },
  methods: {
    getScharffDistrics,
    getSizes,
    invalidateFare() {
      this.fareRequests.invalidate()
      this.shippingCost = 0
      this.aditionalCostCalculated = 0
      this.classificationError = ''
      if (this.isManualMode) this.effectiveSize = null
    },
    async classifyManualSize() {
      const classifiedSize = await classifySize({
        width: Number(this.packageWidth),
        height: Number(this.packageHeight),
        deep: Number(this.packageDeep),
        weight: Number(this.packageWeight),
        shippingTypeId: this.shippingTypeId,
      })
      return {
        ...classifiedSize,
        tallaId: classifiedSize.sizeId,
        codigo: classifiedSize.code,
        descripcion: classifiedSize.description,
      }
    },
    // CustomSearchSelect renders point options from these lowercase fields.
    toPointOption(rawPoint) {
      const point = normalizeScharffPoint(rawPoint)
      if (!point?.ScharffPointId) return null
      return {
        ...point,
        id: point.ScharffPointId,
        name: point.Name,
        address: point.Address,
        district: point.district || point.DistritoTexto,
        labelAfterSelect: point.labelAfterSelect || point.Name,
      }
    },
    restoreDestinationDistrict(district) {
      if (!district?.id) return
      // Assign first, or setDestinationDistrictData reads it as a change and wipes the point.
      this.destinationDistrictData = { ...district, textToFind: district.textToFinded || '' }
      this.$refs.CustomSelectComponentRef?.restoreSelection(district)
    },
    setDestinationDistrictData(districtData) {
      if (this.destinationDistrictData.id && this.destinationDistrictData.id !== districtData.id) {
        this.destinationPuntoScharff = ''
        this.selectedScharffPointData = {}
      }
      if([67, 128].includes(districtData.provinceId)) { // callao y lima
        this.secondAttemptInPS = this.secondAttemptInPS ?? true
        this.allowSecondAttempt = true
      } else {
        this.allowSecondAttempt = false
        this.secondAttemptInPS = null
      }
      this.destinationDistrictData = districtData
    },
    async checkValues() {
      try {
        const {
          DestinationAddress, destinationDistrictId,
          DestinationContact, securityCode, productDescription,
          packageValue, hasLimaOrCallaoDistrict,
          destinationPuntoScharff, shipmentType, typesOfShipments
        } = this

        const idOfDistrict = shipmentType === typesOfShipments.pointToHome ?
            DestinationAddress?.districtId :
            destinationDistrictId

        const hasValueCalculable = (
          idOfDistrict && hasLimaOrCallaoDistrict &&
          this.hasValidPackageSize &&
          this.isSelectedSizeCompatible
        )

        const commonConditions = (
          hasValueCalculable &&
          this.shippingCost > 0 &&
          DestinationContact &&
          productDescription &&
          !this.shippingCostIsLoading &&
          !!packageValue
        )

        if (shipmentType === typesOfShipments.pointToHome) {
          this.package.isAddableToList = !!commonConditions
        }

        // validate if securityCode has 4 digits
        const securityCodeValid = securityCode && /^\d{4}$/.test(securityCode)

        if (shipmentType === typesOfShipments.pointToPoint) {
          this.package.isAddableToList = securityCodeValid && !!commonConditions && !!destinationPuntoScharff
        }

        console.log('hasValueCalculable', hasValueCalculable)
        console.log('this.shippingCost', this.shippingCost)
        console.log('DestinationContact', DestinationContact)
        console.log('securityCode', securityCode)
        console.log('productDescription', productDescription)
        console.log('this.shippingCostIsLoading', this.shippingCostIsLoading)
        console.log('packageValue', packageValue)
        console.log('commonConditions', commonConditions)
        console.log('this.package.isAddableToList', this.package.isAddableToList)
        console.log('_________________')
      } catch (e) {
        console.log("Error in checkValues:", e)
      }
    },
    async checkValuesToCalculate() {
      try {
        const {
          DestinationAddress, destinationDistrictId, hasLimaOrCallaoDistrict,
          shipmentType, typesOfShipments
        } = this

        const idOfDistrict = shipmentType === typesOfShipments.pointToHome ?
            DestinationAddress?.districtId :
            destinationDistrictId

        const hasValueCalculable = (
          idOfDistrict && hasLimaOrCallaoDistrict &&
          this.canStartFareCalculation
        )

        this.package.hasValueCalculable = hasValueCalculable

        if (hasValueCalculable) await this.calculateCost()
        else this.shippingCost = 0
        this.shippingCostIsLoading = false
      } catch (e) {
        console.log("Error in checkValuesToCalculate:", e)
      }
    },
    async calculateCost() {
      if (!this.canStartFareCalculation) {
        this.shippingCost = 0
        return
      }
      this.shippingCostIsLoading = true
      const requestVersion = this.fareRequests.begin()
      const idOfDestinationDistrict = this.shipmentType === this.typesOfShipments.pointToHome ?
          this.DestinationAddress?.districtId :
          this.destinationDistrictId
      try {
        let sizeForFare = this.sizeSelected
        if (this.isManualMode) {
          sizeForFare = await this.classifyManualSize()
          if (!this.fareRequests.isCurrent(requestVersion)) return
          this.effectiveSize = sizeForFare
          const compatibility = getSizeCompatibility({
            size: sizeForFare,
            shippingTypeId: this.shippingTypeId,
            originPoint: this.originDistric.scharffPoint,
            destinationPoint: this.shipmentType === this.typesOfShipments.pointToPoint ? this.selectedScharffPointData : null,
          })
          if (!compatibility.isAllowed) {
            this.shippingCost = 0
            return
          }
        }
        const fare = await getFare({
          "fareItems": [
            {
              "originDistrictId": this.originDistric.districtId.id,
              "destinationDistrictId": idOfDestinationDistrict,
              "packageWidth": this.isManualMode ? Number(this.packageWidth) : null,
              "packageHeight": this.isManualMode ? Number(this.packageHeight) : null,
              "packageWeight": this.isManualMode ? Number(this.packageWeight) : null,
              "packageDeep": this.isManualMode ? Number(this.packageDeep) : null,
              "serviceType": 4, // puntos
              "sizeId": sizeForFare.tallaId,
              "shippingTypeId": this.shippingTypeId
            }
          ],
          "userId": this.user?.id || null
        })
        if (!this.fareRequests.isCurrent(requestVersion)) return
        this.shippingCost = fare.data.totalFare
        this.aditionalCostCalculated = fare.data.secondTryFare.toFixed(2) || 0
      } catch (e) {
        if (!this.fareRequests.isCurrent(requestVersion)) return
        this.classificationError = this.isManualMode
          ? 'No pudimos clasificar las medidas del paquete. Verifica los datos e inténtalo nuevamente.'
          : ''
        this.shippingCost = 0
        this.$swal({
          title: "Error!",
          text: e,
          icon: "error",
        })
      } finally {
        this.shippingCostIsLoading = false
      }
    },
    handleAddPackage() {
      this.tryToAddPackage = true
      if(!this.package.isAddableToList) {
        this.$swal({
          text: '¡Ups! 😅 Parece que hay algunos campos que aún no has completado correctamente.',
          icon: "warning",
          confirmButtonText: "Aceptar"
        })
        return
      }

      const allPackageData = {
        index: this.$store.getters.SCHARFFPOINT_INDEX_DESTINATION,
        item: {
          description: this.productDescription,
          destinationAddress: {
            additionalAddress: this.reference,
            contact: this.DestinationContact,
            address: this.DestinationAddress,
            description: this.address,
            districtId: {
              id: this.destinationDistrictData.id,
              text: this.destinationDistrictData.text,
              textToFinded: this.destinationDistrictData.textToFind,
              provinceId: this.destinationDistrictData.provinceId,
              departmentId: this.destinationDistrictData.departmentId,
            },
            puntoScharffId: this.selectedScharffPointData
          },
          securityCode: this.securityCode,
          discountFare: null,
          fare: this.shippingCost,
          secondAttemptInPS: this.secondAttemptInPS,
          isPointPoint: this.shipmentType === this.typesOfShipments.pointToPoint,
          packageSize: {
            height: this.isManualMode ? Number(this.packageHeight) : null,
            lengths: this.isManualMode ? Number(this.packageDeep) : null,
            maxWeight: null,
            order: this.isManualMode ? this.effectiveSize.order : this.sizeSelected.order,
            type: this.isManualMode ? this.effectiveSize.code : this.sizeSelected.codigo,
            weight: this.isManualMode ? Number(this.packageWeight) : null,
            width: this.isManualMode ? Number(this.packageWidth) : null
          },
          fragil: this.isAFragileProduct,
          isShippingPaidAtDestination: this.isShippingPaidAtDestination,
          productValue: this.packageValue,
          sizeMode: this.isManualMode ? 'manual' : 'catalog',
          sizeSelected: this.sizeSelected,
          effectiveSize: this.isManualMode ? this.effectiveSize : this.sizeSelected,
          shippingTypeId: this.shippingTypeId
        },
      }
      this.$store.dispatch("SCHARFFPOINT_ORDER_SET_DESTINATION", allPackageData);
      const popup = document.getElementById(this.id)
      popup.classList.remove("is-active");

      this.trackEvent('click_puntos_envia_guardar_paquete', this.shipmentType == this.typesOfShipments.pointToHome ? 'dropoff': 'puntoapunto')
    },
    updateSecondAttemptOption(option) {
      this.secondAttemptInPS = option
    },
    async getScharffPoints() {
      const requestVersion = this.pointListRequests.begin()
      const districtId = this.destinationDistrictId
      this.scharffPointsAreLoading = true
      let response
      try {
        response = await this.$store.dispatch("GET_SCHARFF_POINT", districtId)
      } finally {
        if (this.pointListRequests.isCurrent(requestVersion)) this.scharffPointsAreLoading = false
      }
      if (!this.pointListRequests.isCurrent(requestVersion) || districtId !== this.destinationDistrictId || this.isShippingPaidAtDestination) return
      this.scharffPointsList = normalizeScharffPoints(response)
      this.scharffPointsList.forEach((item) => {
        this.map?.addMarkerScharffPoint(item.Location, item.Name, item.Name, item)
      })
    },
    // The searchable list returns the API2 shape; normalizing keeps setMarketV2 source-agnostic.
    async searchCashOnDeliveryPoints(text) {
      const points = await getScharffPoints(text, { onlyCashOnDelivery: true })
      if (!Array.isArray(points)) return []

      return points.map(point => ({
        ...normalizeScharffPoint(point),
        // Fields CustomSearchSelect needs to render and label each option.
        id: point.puntoScharffId,
        name: point.nombre,
        address: point.direccion,
        district: point.district,
        labelAfterSelect: point.labelAfterSelect,
      }))
    },
    setMarketV2(rawPoint) {
      this.invalidateFare()
      const point = normalizeScharffPoint(rawPoint)
      const { DepartamentoTexto, ProvinciaTexto, DistritoTexto } = point
      if (this.isShippingPaidAtDestination) {
        this.setDestinationDistrictData({
          departmentId: point.DepartamentoId,
          id: point.DistritoId,
          provinceId: point.ProvinciaId,
          text: utils.methods.toCapitalCase(`${DepartamentoTexto} - ${ProvinciaTexto} - ${DistritoTexto}`),
        })
      }
      this.destinationPuntoScharff = point.ScharffPointId
      this.destinationDistrictId = point.DistritoId
      this.selectedScharffPointData = point

      if (point.Location) {
        this.map?.addMarkerScharffPoint(point.Location, point.Name, point.Name, point)
        this.map?.centerMap({ lat: point.Location.Lat, lng: point.Location.Lng })
      }
    },
    async getSizesForSharfPoints(type) {
      const sizes = await this.getSizes(type)
      const personalizedSize = sizes.find(size => size.codigo === CUSTOM_SIZE_CODE)
      this.maxLength = personalizedSize.alto
      this.maxWeight = personalizedSize.pesoMaximo
      this.volumetricRatio = sizes.find(size => Number(size.ratioVolumetrico) > 0)?.ratioVolumetrico || this.volumetricRatio
      this.maxVolumetricWeight = personalizedSize.pesoMaximo * this.volumetricRatio
      this.sizeList = sizes
    },
    handleSizeSelected(size) {
      this.invalidateFare()
      this.sizeSelected = size
      this.packageWeight = 0
      this.packageWidth = 0
      this.packageHeight = 0
      this.packageDeep = 0
    },
    emptySize() {
      return {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      }
    },
    // Manual mode still maps internally to size "P" to keep the order payload unchanged.
    handleSizeModeChange(mode) {
      if (mode === this.packageSizeMode) return
      if (mode === 'manual' && !this.canUseManualMode) return

      this.packageSizeMode = mode
      this.invalidateFare()
      this.effectiveSize = null
      this.classificationError = ''
      this.packageWeight = 0
      this.packageWidth = 0
      this.packageHeight = 0
      this.packageDeep = 0
      this.sizeSelected = mode === 'manual'
        ? this.sizeList.find(size => size.codigo === CUSTOM_SIZE_CODE) || this.emptySize()
        : this.emptySize()
    },
    async openAddressesModal() {
      this.showLoading();
      await this.$store.dispatch('GET_FAVORITE_LOCATIONS')
      const modalAddressFavorite = document.querySelector('#modal-address-destination')
      const instance = M.Modal.init(modalAddressFavorite, {
        dismissible: false
      })
      instance.open()
      this.$swal.close()
    },
    openContactModal(type) {
      this.showLoading();
      this.$store
        .dispatch("GET_CONTACTS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const contacts = success.data.result.list;
            this.$store.dispatch("GENERAL_SET_CONTACTS", contacts);
            this.$store.dispatch("HELPER_SET_MODAL_CONTACT_TYPE", type);
            const modalContactFavorite = document.querySelector("#modal-contact-destination");
            const instance = M.Modal.init(modalContactFavorite, {
              dismissible: false
            });
            instance.open();
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },
    generateSecurityCode() {
      const isAllSame = (code) => /^(\d)\1{3}$/.test(code)
      const isSequence = (code) => {
        const d1 = code[1] - code[0]
        const d2 = code[2] - code[1]
        const d3 = code[3] - code[2]
        return d1 === d2 && d2 === d3 && Math.abs(d1) === 1
      }
    
      let code = ''
      let tries = 0
    
      while (!code || isAllSame(code) || isSequence(code)) {
        code = Math.floor(1000 + Math.random() * 9000).toString()
        tries++
        if (tries > 30) break // por si acaso
      }
    
      this.securityCode = code
    },
    async clearData() {
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", null);
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", null)
      this.shipmentType = this.typesOfShipments.pointToHome
      this.destinationDistrictId = ''
      this.scharffPointsList = []
      this.destinationPuntoScharff = ''
      this.address = ''
      this.reference = ''
      this.securityCode = ''
      this.productDescription = ''
      this.isAFragileProduct = false
      this.isShippingPaidAtDestination = false
      this.packageWeight = 0
      this.packageWidth = 0
      this.packageHeight = 0
      this.packageDeep = 0
      this.packageValue = 0
      this.secondAttemptInPS = true
      this.adicionalInformation = ''
      this.package = {
        hasValueCalculable: false,
        isAddableToList: false
      }
      this.shippingCostIsLoading = false
      this.shippingCost = 0
      this.tryToAddPackage = false
      this.destinationDistrictData = {}
      this.selectedScharffPointData = {}
      this.scharffPointsAreLoading = false
      this.sizeSelected = this.emptySize()
      this.packageSizeMode = 'catalog'
      this.effectiveSize = null
      this.classificationError = ''
      this.fareRequests.invalidate()
      this.pointListRequests.invalidate()
    },
    async setData(destination) {
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", destination.destinationAddress.contact);
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", destination.destinationAddress.address)
      this.shipmentType = destination.isPointPoint ? this.typesOfShipments.pointToPoint : this.typesOfShipments.pointToHome
      this.isShippingPaidAtDestination = destination.isShippingPaidAtDestination
      this.destinationPuntoScharff = destination.destinationAddress.puntoScharffId?.ScharffPointId || ''
      this.selectedScharffPointData = destination.destinationAddress.puntoScharffId ? {
        ...destination.destinationAddress.puntoScharffId,
        maximumSize: normalizePointMaximumSize(destination.destinationAddress.puntoScharffId),
      } : null
      this.address = destination.destinationAddress.description
      this.reference = destination.destinationAddress.additionalAddress
      this.securityCode = destination.securityCode
      this.productDescription = destination.description
      this.packageWeight = destination.packageSize.weight || 0
      this.packageWidth = destination.packageSize.width || 0
      this.packageHeight = destination.packageSize.height || 0
      this.packageDeep = destination.packageSize.lengths || 0
      this.packageValue = destination.productValue
      this.secondAttemptInPS = destination.secondAttemptInPS
      this.isAFragileProduct = destination.fragil
      this.package = {
        hasValueCalculable: true,
        isAddableToList: true
      }
      this.shippingCostIsLoading = false
      this.shippingCost = destination.fare
      this.tryToAddPackage = false

      this.packageSizeMode = destination.sizeMode === 'manual' ? 'manual' : 'catalog'
      this.sizeSelected = destination.sizeMode === 'manual'
        ? this.sizeList.find(size => size.codigo === CUSTOM_SIZE_CODE) || destination.sizeSelected
        : destination.sizeSelected
      this.effectiveSize = destination.effectiveSize || (destination.sizeMode === 'manual' ? destination.packageSize : null)

      // nextTick runs after the isShippingPaidAtDestination watcher, which clears the destination.
      this.$nextTick(() => {
        if (!destination.isPointPoint) return
        if (destination.isShippingPaidAtDestination) {
          this.setMarketV2(destination.destinationAddress.puntoScharffId)
          this.$refs.cashOnDeliveryPointRef?.restoreSelection(
            this.toPointOption(destination.destinationAddress.puntoScharffId)
          )
        } else {
          this.restoreDestinationDistrict(destination.destinationAddress.districtId)
          this.destinationPuntoScharff = destination.destinationAddress.puntoScharffId?.ScharffPointId || ''
        }
        // restoreDestinationDistrict re-runs setDestinationDistrictData, which recomputes this.
        this.secondAttemptInPS = destination.secondAttemptInPS
      })
    },
  },
  created () {
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.destinationPuntoScharff,
      this.shipmentType,
      this.address,
      this.DestinationContact,
      this.securityCode,
      this.productDescription,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
      this.packageValue,
      this.shippingCost,
      this.shippingCostIsLoading,
    ], () => { this.checkValues() })
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.destinationPuntoScharff,
      this.shipmentType,
      this.sizeSelected.tallaId,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ], debounce(this.checkValuesToCalculate, 300))
    this.$watch(() => [
      this.DestinationAddress,
      this.destinationDistrictId,
      this.destinationPuntoScharff,
      this.shipmentType,
      this.sizeSelected.tallaId,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ],() => {
      this.invalidateFare()
      this.shippingCostIsLoading = this.canStartFareCalculation
    })
    this.$watch('destinationDistrictId', value => {
      if (value && !this.isShippingPaidAtDestination) {
        this.getScharffPoints()
      }
    })
    this.$watch('isShippingPaidAtDestination', value => {
      this.pointListRequests.invalidate()
      this.destinationDistrictId = ''
      this.destinationPuntoScharff = ''
      this.destinationDistrictData = {}
      this.selectedScharffPointData = {}
      // Paying at destination searches on demand, so no list is preloaded.
      this.scharffPointsList = []
    })

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)) {
      this.$nextTick(() => {
        const appContainer = document.querySelector('.body_add_packagev2');
        if (appContainer) {
          appContainer.classList.add('ios-safari');
        }
      });
    }
  },
  mounted() {
    try {
      this.map = new Map();
      this.map.initMap("mp_ps_type1");
      this.initSelects();
      this.$eventBus.$on("scharffPointClearDataDestinationModal", () => {
        this.clearData();
      });

      this.$eventBus.$on("scharffPointSetDataDestinationModal", (destination) => {
        this.setData(destination);
      });
      this.getSizesForSharfPoints(CUSTOM_SIZE_CODE)
    } catch (e) {
      console.error("Error al montar el componente ModalScharffPointPackageV2:", e);
    }
  },
  computed: {
    shippingTypeId() {
      return this.shipmentType === this.typesOfShipments.pointToHome ? 1 :
        this.shipmentType === this.typesOfShipments.pointToPoint ? 3 : null
    },
    isManualMode() {
      return this.packageSizeMode === 'manual'
    },
    canUseManualMode() {
      return this.manualSizeOptionCompatibility.isAllowed
    },
    volumetricWeightKg() {
      return Math.round(this.volumetricWeight / this.volumetricRatio * 100) / 100
    },
    hasValidManualMeasurements() {
      return Number(this.packageWeight) > 0 && !this.exceedsWeightLimit &&
        Number(this.packageWidth) > 0 && this.packageWidth <= this.maxLength &&
        Number(this.packageHeight) > 0 && this.packageHeight <= this.maxLength &&
        Number(this.packageDeep) > 0 && this.packageDeep <= this.maxLength &&
        !this.exceedsVolumetricWeight
    },
    manualSizeOptionCompatibility() {
      return getManualSizeOptionCompatibility({
        shippingTypeId: this.shippingTypeId,
        originPoint: this.originDistric.scharffPoint,
        destinationPoint: this.shipmentType === this.typesOfShipments.pointToPoint ? this.selectedScharffPointData : null,
      })
    },
    capacityCompatibility() {
      if (this.isManualMode) return this.manualSizeOptionCompatibility
      return getSizeCompatibility({
        size: this.sizeSelected,
        shippingTypeId: this.shippingTypeId,
        originPoint: this.originDistric.scharffPoint,
        destinationPoint: this.shipmentType === this.typesOfShipments.pointToPoint ? this.selectedScharffPointData : null,
      })
    },
    canStartFareCalculation() {
      return !!this.sizeSelected.tallaId && this.capacityCompatibility.isAllowed &&
        (!this.isManualMode || this.hasValidManualMeasurements)
    },
    hasValidPackageSize() {
      return this.canStartFareCalculation && (!this.isManualMode || !!this.effectiveSize)
    },
    compatibleSizeList() {
      return decorateSizesWithCompatibility(this.sizeList, {
        shippingTypeId: this.shippingTypeId,
        originPoint: this.originDistric.scharffPoint,
        destinationPoint: this.shipmentType === this.typesOfShipments.pointToPoint ? this.selectedScharffPointData : null,
      })
    },
    selectedSizeCompatibility() {
      if (this.isManualMode && !this.effectiveSize) return this.manualSizeOptionCompatibility
      return getSizeCompatibility({
        size: this.isManualMode ? this.effectiveSize : this.sizeSelected,
        shippingTypeId: this.shippingTypeId,
        originPoint: this.originDistric.scharffPoint,
        destinationPoint: this.shipmentType === this.typesOfShipments.pointToPoint ? this.selectedScharffPointData : null,
      })
    },
    isSelectedSizeCompatible() {
      return this.selectedSizeCompatibility.isAllowed
    },
    selectedSizeCompatibilityMessage() {
      return this.sizeSelected?.tallaId && !this.isSelectedSizeCompatible
        ? this.selectedSizeCompatibility.reason
        : ''
    },
    user() {
      return this.$store.getters.USER;
    },
    hasLimaOrCallaoDistrict() {
      const originDistrict = `${this.originDistric.districtId?.text || ''}`
      const destinationDistrict = this.destinationDistrictData?.text || ''
      const originAndDestinationDistricts = `${originDistrict}${destinationDistrict}`
      return originDistrict && destinationDistrict ? originAndDestinationDistricts.toLowerCase().includes('lima') || originAndDestinationDistricts.toLowerCase().includes('callao') : true
    },
    originDistric() {
      return this.$store.getters.SCHARFFPOINT_ORDER_ORIGIN;
    },
    exceedsWeightLimit() {
      return this.packageWeight > this.maxWeight
    },
    volumetricWeight() {
      const a = this.packageWidth
      const b = this.packageHeight
      const c = this.packageDeep
      return a * b * c
    },
    exceedsVolumetricWeight() {
      if (this.sizeSelected.codigo !== CUSTOM_SIZE_CODE) return false
      return this.volumetricWeight > this.maxVolumetricWeight
    },
    volumetricWeightMsg() {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }); 
      const maxValue = this.maxVolumetricWeight
      const currentValue = this.volumetricWeight
      return `El volumen máximo por paquete en el servicio Puntos Sharf es ${formatter.format(maxValue)} cm³. Has ingresado un volumen de ${formatter.format(currentValue)} cm³.`
    },
    DestinationContact() {
      return this.$store.getters.GENERAL_DESTINATION_CONTACT;
    },
    DestinationAddress() {
      return this.$store.getters.GENERAL_DESTINATION_ADDRESS
    },
  },
  watch:{
    securityCode(value) {
      if (value) {
        const onlyDigits = value.replace(/\D/g, '').slice(0, 4)
        this.securityCode = onlyDigits
      } else {
        this.securityCode = ''
      }
    },
    shipmentType(value){
      if(value == this.typesOfShipments.pointToHome){
        this.trackEvent('click_puntos_envia_paso_3_a_domicilio', 'dropoff')
        this.isShippingPaidAtDestination = false
      }else{
        this.trackEvent('click_puntos_envia_paso_3_a_punto', 'puntoapunto')
      }
    }
  }
};
</script>

<style>
@import '../../styles/09-componentsv2/addPackage.scss';

.size_mode_selector {
  display: flex;
  flex-direction: column;
  margin: -12px -12px 8px -12px;
}

.calculated_size {
  margin-top: 16px;
  padding: 16px;
  border-radius: 12px;
  /* Same states as the POS card: green when the size fits, red when it does not. */
  border: 1px solid rgba(0, 204, 170, 0.4);
  background: rgba(153, 235, 221, 0.25);
}

.calculated_size.is-invalid {
  border-color: #FCA5A5;
  background: #FEF2F2;
}

.calculated_size--value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.calculated_size--error {
  margin-top: 10px;
  font-size: 13px;
  color: #B20000;
}

.calculated_size--head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #E5E5E5;
}

.calculated_size--detail {
  list-style: none;
  margin: 0;
  padding: 0;
}

.calculated_size--detail li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  padding: 3px 0;
}

.calculated_size--detail li span {
  color: #737373;
}

.calculated_size--formula {
  display: block !important;
  font-size: 12px !important;
  color: #909090;
  font-style: italic;
}





[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}

/* Base styles for the entire tooltip */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after {
  position: absolute;
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  -webkit-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, -webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -moz-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, -moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  pointer-events: none;
}

/* Show the entire tooltip on hover and focus */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}

/* Base styles for the tooltip's directional arrow */
.tooltip:before,
[data-tooltip]:before {
  z-index: 1001;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Base styles for the tooltip's content area */
.tooltip:after,
[data-tooltip]:after {
  z-index: 1000;
  padding: 8px;
  width: 160px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.2;
}

/* Directions */

/* Top (default) */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after,
.tooltip-top:before,
.tooltip-top:after {
  bottom: 100%;
  left: 50%;
}

[data-tooltip]:before,
.tooltip:before,
.tooltip-top:before {
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: #000;
  border-top-color: hsla(0, 0%, 20%, 0.9);
}

/* Horizontally align top/bottom tooltips */
[data-tooltip]:after,
.tooltip:after,
.tooltip-top:after {
  margin-left: -80px;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after,
.tooltip-top:hover:before,
.tooltip-top:hover:after,
.tooltip-top:focus:before,
.tooltip-top:focus:after {
  -webkit-transform: translateY(-12px);
  -moz-transform: translateY(-12px);
  transform: translateY(-12px);
}

/* Left */
.tooltip-left:before,
.tooltip-left:after {
  right: 100%;
  bottom: 50%;
  left: auto;
}

.tooltip-left:before {
  margin-left: 0;
  margin-right: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-left-color: #000;
  border-left-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-left:hover:before,
.tooltip-left:hover:after,
.tooltip-left:focus:before,
.tooltip-left:focus:after {
  -webkit-transform: translateX(-12px);
  -moz-transform: translateX(-12px);
  transform: translateX(-12px);
}

/* Bottom */
.tooltip-bottom:before,
.tooltip-bottom:after {
  top: 100%;
  bottom: auto;
  left: 50%;
}

.tooltip-bottom:before {
  margin-top: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-bottom-color: #000;
  border-bottom-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-bottom:hover:before,
.tooltip-bottom:hover:after,
.tooltip-bottom:focus:before,
.tooltip-bottom:focus:after {
  -webkit-transform: translateY(12px);
  -moz-transform: translateY(12px);
  transform: translateY(12px);
}

/* Right */
.tooltip-right:before,
.tooltip-right:after {
  bottom: 50%;
  left: 100%;
}

.tooltip-right:before {
  margin-bottom: 0;
  margin-left: -12px;
  border-top-color: transparent;
  border-right-color: #000;
  border-right-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-right:hover:before,
.tooltip-right:hover:after,
.tooltip-right:focus:before,
.tooltip-right:focus:after {
  -webkit-transform: translateX(12px);
  -moz-transform: translateX(12px);
  transform: translateX(12px);
}

/* Move directional arrows down a bit for left/right tooltips */
.tooltip-left:before,
.tooltip-right:before {
  top: 3px;
}

/* Vertically center tooltip content for left/right tooltips */
.tooltip-left:after,
.tooltip-right:after {
  margin-left: 0;
  margin-bottom: -16px;
}

@media screen and (max-device-width: 580px) {
  .ios-safari {
    padding-bottom:10em;
  }
}
</style>
